// Both wizards enter the shared capability-governed step. The UI must describe
// the recorded phone state, not infer a disabled provider from missing data.
export const ENABLE_ONBOARDING_PHONE_OTP = true;

export const PHONE_VERIFICATION_NOT_STARTED_LABEL =
  "Phone not provided — verification not started";

export const PHONE_VERIFICATION_PENDING_LABEL =
  "Phone captured — verification pending";

export function buildOnboardingIntroSteps(steps = []) {
  if (ENABLE_ONBOARDING_PHONE_OTP) return steps;
  return steps.filter((step) => step !== "otp");
}

export function normalizeIntroStepForPhoneOtpFlag(rawStep, baseSteps = [], activeSteps = []) {
  const numericStep = Number(rawStep);
  if (!Number.isFinite(numericStep)) return 0;

  const max = Math.max(activeSteps.length - 1, 0);
  if (ENABLE_ONBOARDING_PHONE_OTP) {
    return Math.min(Math.max(numericStep, 0), max);
  }

  const otpIndex = baseSteps.indexOf("otp");
  if (otpIndex === -1) return Math.min(Math.max(numericStep, 0), max);
  if (numericStep > otpIndex) return Math.min(Math.max(numericStep - 1, 0), max);
  return Math.min(Math.max(numericStep, 0), max);
}
